import React from 'react';
import { Col, Row } from 'react-bootstrap';
import { ListedMassMail } from 'helper/mailer';
import Icon from 'components/DesignSystem/Icon';
import { cssVar } from 'constants/theme';

const ACTIVE_COLOR = cssVar('success-solid');
const INACTIVE_COLOR = cssVar('text-disabled');

export default function MassEmailRow({ massEmail }: {
  massEmail: ListedMassMail,
}) {
  return (
    <Row className="mb-3">
      <Col md={4}>
        {massEmail.identifierCode}
      </Col>
      <Col md={4}>
        {massEmail.subject}
      </Col>
      <Col md={3}>
        {massEmail.sendDate}
      </Col>
      <Col md={1} className="d-flex justify-content-center">
        <Icon
          id="mass-email-status-icon"
          iconType="checkmark"
          color={massEmail.isFinished ? ACTIVE_COLOR : INACTIVE_COLOR}
        />
      </Col>
    </Row>
  );
}
